import $ from 'jquery';

/**
 *
 * @param {Element} element
 */
function highlightElement(element) {
  var highlightClass = '-highlight';
  var highlighted = document.querySelectorAll('.' + highlightClass);
  if (highlighted) {
    highlighted.forEach(el => {
      if (el !== element) {
        el.classList.remove(highlightClass);
      }
    });
  }
  element.classList.add(highlightClass);
}

/**
 * Scroll to an element on the page
 * @param {Element} element
 */
function scrollToElement(element) {
  var rm = window.matchMedia('(prefers-reduced-motion)');
  var y = element.offsetTop - 70; // see $header-height-mobile in _variables.scss
  if (rm.matches) {
    // a11y addition, let's the user decide to opt out of smooth scrolling
    window.scrollTo(
      0, y
    );
  } else {
    try {
      window.scrollTo({
        left: 0,
        top: y,
        behavior: 'smooth'
      });
    } catch (e) {
      window.scrollTo(
        0, y
      );
    }
  }
}

/**
 *
 * @param {Event} event
 */
function onClick(event) {
  var destSelector = event.currentTarget.getAttribute('href');
  var destElement = document.querySelector(destSelector);
  if (destElement) {
    scrollToElement(destElement);
    highlightElement(destElement);
    destElement.focus();
  }
  event.preventDefault();
}

$(function () {
  var links = document.querySelectorAll('.admission-list a');
  if (links) {
    links.forEach(link => {
      link.addEventListener('click', onClick);
    });
  }
});
